// SalesSummaryReport.jsx
import React from 'react';
import ReportTemplate from './reportTemplate';

const SalesSummaryReport = () => <ReportTemplate reportType="Sales Summary" pageTitle="Sales Summary (Sales Total)" csvFilePrefix="sales-summary-total" />;

export default SalesSummaryReport;
